<template>
    <div>
        <SingleSelect v-if="isSingleSelect" :slug="slug" :isSmallLabel="isSmallLabel" :filterValues="filterValues" :label="title" @filterChange="onFilterChange"> </SingleSelect>
        <MultiSelect v-else :slug="slug" :isSmallLabel="isSmallLabel" :filterValues="filterValues" :label="title" @filterChange="onFilterChange"></MultiSelect>
    </div>
</template>

<script lang="ts">
import { FilterValue } from 'Vue/interfaces/LockDesigner';
import MultiSelect from './MultiSelect.vue';
import SingleSelect from './SingleSelect.vue';
export default {
    name: 'Dropdown',
    props: {
        slug: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        displayExpanded: {
            type: Boolean,
            default: false,
        },
        isSingleSelect: {
            type: Boolean,
            default: false,
        },
        hasFilters: {
            type: Boolean,
            default: false,
        },
        filterValues: {
            type: Array,
            required: true,
        },
        isSmallLabel: {
            type: Boolean,
            default: false,
        },
        description: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            selectedValue: null, // Track the selected value
        };
    },
    methods: {
        onFilterChange(filterValues: FilterValue[]) {
            this.$emit('filterChange', { slug: this.slug, filterValues });
        },
        onInfoButtonClick() {
            this.$emit('infoButtonClick');
        },
    },
    components: { MultiSelect, SingleSelect },
};
</script>
